import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  container?: Element;
}

/**
 * Обёртка для react-портала.
 * @description Позволяет отображать дочерние элементы в отдельном контейнере,
 * например Modal или Popover вне иерархии DOM-дерева.
 */
export const Portal = ({ children, container = document.body }: PortalProps) =>
  createPortal(children, container);
